module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_kikin-ee7a708c60a5c315989e3b3faff8fbd1.png";